// // import React, { useEffect } from "react";
// // import PropTypes from "prop-types";
// // import dayjs from "dayjs";

// // import SoftInput from "components/SoftInput";
// // import SoftSelect from "components/SoftSelect";
// // import SoftBox from "components/SoftBox";
// // import SoftTypography from "components/SoftTypography";

// // import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// // const UserFilters = ({
// //   filters,
// //   onFilterChange,
// //   searchTerm,
// //   onSearchChange,
// //   dropdownOptions,
// //   fetchShiftsForBranch,
// //   showHistoryFilters = false, // ✅ only history
// // }) => {
// //   /* ---------------- BRANCH → SHIFT ---------------- */
// //   useEffect(() => {
// //     if (filters.branch_id) {
// //       fetchShiftsForBranch(filters.branch_id);
// //     } else {
// //       fetchShiftsForBranch(null);
// //     }
// //   }, [filters.branch_id, fetchShiftsForBranch]);

// //   const getSelected = (key, options) =>
// //     options.find((o) => String(o.value) === String(filters[key])) || options[0];

// //   return (
// //     <div className="container-fluid">
// //       {/* =================================================
// //           ROW 1 → COMMON FILTERS
// //       ================================================= */}
// //       <div className="row g-3 align-items-end">
// //         <div className="col-md">
// //           <SoftSelect
// //             label="Branch"
// //             size="medium"
// //             value={getSelected("branch_id", [
// //               { value: "", label: "All Branches" },
// //               ...dropdownOptions.branches.map((b) => ({
// //                 value: String(b.id),
// //                 label: b.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => {
// //               onFilterChange("branch_id", value);
// //               onFilterChange("shift_id", "");
// //             }}
// //             options={[
// //               { value: "", label: "All Branches" },
// //               ...dropdownOptions.branches.map((b) => ({
// //                 value: String(b.id),
// //                 label: b.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Shift"
// //             size="medium"
// //             isDisabled={!filters.branch_id}
// //             value={getSelected("shift_id", [
// //               { value: "", label: "All Shifts" },
// //               ...(filters.branch_id
// //                 ? dropdownOptions.shifts.map((s) => ({
// //                     value: String(s.id),
// //                     label: s.label,
// //                   }))
// //                 : []),
// //             ])}
// //             onChange={({ value }) => onFilterChange("shift_id", value)}
// //             options={[
// //               {
// //                 value: "",
// //                 label: filters.branch_id ? "All Shifts" : "Choose branch first",
// //               },
// //               ...(filters.branch_id
// //                 ? dropdownOptions.shifts.map((s) => ({
// //                     value: String(s.id),
// //                     label: s.label,
// //                   }))
// //                 : []),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Department"
// //             size="medium"
// //             value={getSelected("department_id", [
// //               { value: "", label: "All Departments" },
// //               ...dropdownOptions.departments.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => onFilterChange("department_id", value)}
// //             options={[
// //               { value: "", label: "All Departments" },
// //               ...dropdownOptions.departments.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Designation"
// //             size="medium"
// //             value={getSelected("designation_id", [
// //               { value: "", label: "All Designations" },
// //               ...dropdownOptions.designations.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => onFilterChange("designation_id", value)}
// //             options={[
// //               { value: "", label: "All Designations" },
// //               ...dropdownOptions.designations.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Role"
// //             size="medium"
// //             value={getSelected("role", [
// //               { value: "", label: "All Roles" },
// //               { value: "Admin", label: "Admin" },
// //               { value: "HR", label: "HR" },
// //               { value: "Manager", label: "Manager" },
// //               { value: "Team Leader", label: "Team Leader" },
// //               { value: "User", label: "User" },
// //             ])}
// //             onChange={({ value }) => onFilterChange("role", value)}
// //             options={[
// //               { value: "", label: "All Roles" },
// //               { value: "Admin", label: "Admin" },
// //               { value: "HR", label: "HR" },
// //               { value: "Manager", label: "Manager" },
// //               { value: "Team Leader", label: "Team Leader" },
// //               { value: "User", label: "User" },
// //             ]}
// //           />
// //         </div>
// //       </div>

// //       {/* =================================================
// //           ROW 2 → HISTORY FILTERS ONLY
// //       ================================================= */}
// //   <div className="row g-3 mt-3 align-items-end">

// //   {/* ================= HISTORY FILTERS ================= */}
// //   {showHistoryFilters && (
// //     <>
// //       {/* FROM DATE */}
// //       <div className="col-md-3">
// //         <SoftBox
// //           onClick={(e) => onFilterChange("__open_from__", e.currentTarget)}
// //           sx={dateBoxStyle}
// //         >
// //           <CalendarTodayIcon fontSize="small" sx={{ color: "#6b7280" }} />
// //           <SoftTypography sx={dateTextStyle}>
// //             {filters.from
// //               ? dayjs(filters.from).format("DD-MMM-YYYY")
// //               : "From Date"}
// //           </SoftTypography>
// //         </SoftBox>
// //       </div>

// //       {/* TO DATE */}
// //       <div className="col-md-3">
// //         <SoftBox
// //           onClick={(e) => onFilterChange("__open_to__", e.currentTarget)}
// //           sx={dateBoxStyle}
// //         >
// //           <CalendarTodayIcon fontSize="small" sx={{ color: "#6b7280" }} />
// //           <SoftTypography sx={dateTextStyle}>
// //             {filters.to
// //               ? dayjs(filters.to).format("DD-MMM-YYYY")
// //               : "To Date"}
// //           </SoftTypography>
// //         </SoftBox>
// //       </div>

// //       {/* LEAVE TYPE */}
// //       <div className="col-md-3">
// //         <SoftSelect
// //           label="Leave Type"
// //           size="medium"
// //           value={filters.leave_policy_id || ""}
// //           options={[
// //             { value: "", label: "All Leave Types" },
// //             { value: "1", label: "Sick Leave" },
// //             { value: "2", label: "Casual Leave" },
// //           ]}
// //           onChange={({ value }) =>
// //             onFilterChange("leave_policy_id", value)
// //           }
// //         />
// //       </div>
// //     </>
// //   )}

// //   {/* ================= SEARCH (ALWAYS VISIBLE) ================= */}
// //   <div className="col-md-3 ms-auto">
// //     <SoftInput
// //       label="Search"
// //       placeholder="Search by name or email"
// //       value={searchTerm}
// //       onChange={(e) => onSearchChange(e.target.value)}
// //     />
// //   </div>

// // </div>

// //     </div>
// //   );
// // };

// // /* ---------------- STYLES ---------------- */
// // const dateBoxStyle = {
// //   border: "1px solid #d1d5db",
// //   borderRadius: "6px",
// //   px: 1.2,
// //   py: 0.6,
// //   cursor: "pointer",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: 0.8,
// //   minHeight: "36px",
// //   background : "white"
// // };

// // const dateTextStyle = {
// //   fontSize: "0.75rem",
// //   color: "#6b7280",
// //   fontWeight: 400,
// // };

// // UserFilters.propTypes = {
// //   filters: PropTypes.object.isRequired,
// //   onFilterChange: PropTypes.func.isRequired,
// //   searchTerm: PropTypes.string.isRequired,
// //   onSearchChange: PropTypes.func.isRequired,
// //   dropdownOptions: PropTypes.object.isRequired,
// //   fetchShiftsForBranch: PropTypes.func.isRequired,
// //   showHistoryFilters: PropTypes.bool,
// // };

// // export default UserFilters;

// // import React, { useEffect, useState } from "react";
// // import PropTypes from "prop-types";
// // import dayjs from "dayjs";

// // import SoftInput from "components/SoftInput";
// // import SoftSelect from "components/SoftSelect";
// // import SoftBox from "components/SoftBox";
// // import SoftTypography from "components/SoftTypography";

// // import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// // // ✅ API
// // import { usersVisibleLeavePolicy } from "api/users";
// // import { getLeavePolicies } from "api/leave";

// // const UserFilters = ({
// //   filters,
// //   onFilterChange,
// //   searchTerm,
// //   onSearchChange,
// //   dropdownOptions,
// //   fetchShiftsForBranch,
// //   showHistoryFilters = false,
// // }) => {
// //   /* ---------------- BRANCH → SHIFT ---------------- */
// //   useEffect(() => {
// //     if (filters.branch_id) {
// //       fetchShiftsForBranch(filters.branch_id);
// //     } else {
// //       fetchShiftsForBranch(null);
// //     }
// //   }, [filters.branch_id, fetchShiftsForBranch]);

// //   /* ---------------- LEAVE TYPE (DYNAMIC) ---------------- */
// //   const [leaveTypeOptions, setLeaveTypeOptions] = useState([
// //     { value: "", label: "All Leave Types" },
// //   ]);
// //   const [leaveLoading, setLeaveLoading] = useState(false);

// //   useEffect(() => {
// //     if (!showHistoryFilters) return;

// //     const userId = localStorage.getItem("loggedUserId");
// //     if (!userId) return;

// //     const fetchLeaveTypes = async () => {
// //       try {
// //         setLeaveLoading(true);
// //         const res = await getLeavePolicies(userId);
// // console.log(res)
// //         const options = [
// //           { value: "", label: "All Leave Types" },
// //           ...(res || []).map((p) => ({
// //             value: String(p.id),
// //             label: `${p.leave_name} (${p.leave_code})`,
// //           })),
// //         ];

// //         setLeaveTypeOptions(options);
// //       } catch (e) {
// //         console.error("Failed to load leave types", e);
// //       } finally {
// //         setLeaveLoading(false);
// //       }
// //     };

// //     fetchLeaveTypes();
// //   }, [showHistoryFilters]);

// //   const getSelected = (key, options) =>
// //     options.find((o) => String(o.value) === String(filters[key])) || options[0];

// //   return (
// //     <div className="container-fluid">
// //       {/* =================================================
// //           ROW 1 → COMMON FILTERS
// //       ================================================= */}
// //       <div className="row g-3 align-items-end">
// //         <div className="col-md">
// //           <SoftSelect
// //             label="Branch"
// //             value={getSelected("branch_id", [
// //               { value: "", label: "All Branches" },
// //               ...dropdownOptions.branches.map((b) => ({
// //                 value: String(b.id),
// //                 label: b.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => {
// //               onFilterChange("branch_id", value);
// //               onFilterChange("shift_id", "");
// //             }}
// //             options={[
// //               { value: "", label: "All Branches" },
// //               ...dropdownOptions.branches.map((b) => ({
// //                 value: String(b.id),
// //                 label: b.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Shift"
// //             isDisabled={!filters.branch_id}
// //             value={getSelected("shift_id", [
// //               { value: "", label: "All Shifts" },
// //               ...(filters.branch_id
// //                 ? dropdownOptions.shifts.map((s) => ({
// //                     value: String(s.id),
// //                     label: s.label,
// //                   }))
// //                 : []),
// //             ])}
// //             onChange={({ value }) => onFilterChange("shift_id", value)}
// //             options={[
// //               {
// //                 value: "",
// //                 label: filters.branch_id
// //                   ? "All Shifts"
// //                   : "Choose branch first",
// //               },
// //               ...(filters.branch_id
// //                 ? dropdownOptions.shifts.map((s) => ({
// //                     value: String(s.id),
// //                     label: s.label,
// //                   }))
// //                 : []),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Department"
// //             value={getSelected("department_id", [
// //               { value: "", label: "All Departments" },
// //               ...dropdownOptions.departments.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => onFilterChange("department_id", value)}
// //             options={[
// //               { value: "", label: "All Departments" },
// //               ...dropdownOptions.departments.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Designation"
// //             value={getSelected("designation_id", [
// //               { value: "", label: "All Designations" },
// //               ...dropdownOptions.designations.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => onFilterChange("designation_id", value)}
// //             options={[
// //               { value: "", label: "All Designations" },
// //               ...dropdownOptions.designations.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Role"
// //             value={getSelected("role", [
// //               { value: "", label: "All Roles" },
// //               { value: "Admin", label: "Admin" },
// //               { value: "HR", label: "HR" },
// //               { value: "Manager", label: "Manager" },
// //               { value: "Team Leader", label: "Team Leader" },
// //               { value: "User", label: "User" },
// //             ])}
// //             onChange={({ value }) => onFilterChange("role", value)}
// //             options={[
// //               { value: "", label: "All Roles" },
// //               { value: "Admin", label: "Admin" },
// //               { value: "HR", label: "HR" },
// //               { value: "Manager", label: "Manager" },
// //               { value: "Team Leader", label: "Team Leader" },
// //               { value: "User", label: "User" },
// //             ]}
// //           />
// //         </div>
// //       </div>

// //       {/* =================================================
// //           ROW 2 → HISTORY FILTERS
// //       ================================================= */}
// //       <div className="row g-3 mt-3 align-items-end">
// //         {showHistoryFilters && (
// //           <>
// //             {/* FROM DATE */}
// //             <div className="col-md-3">
// //               <SoftBox
// //                 onClick={(e) => onFilterChange("__open_from__", e.currentTarget)}
// //                 sx={dateBoxStyle}
// //               >
// //                 <CalendarTodayIcon fontSize="small" sx={{ color: "#6b7280" }} />
// //                 <SoftTypography sx={dateTextStyle}>
// //                   {filters.from
// //                     ? dayjs(filters.from).format("DD-MMM-YYYY")
// //                     : "From Date"}
// //                 </SoftTypography>
// //               </SoftBox>
// //             </div>

// //             {/* TO DATE */}
// //             <div className="col-md-3">
// //               <SoftBox
// //                 onClick={(e) => onFilterChange("__open_to__", e.currentTarget)}
// //                 sx={dateBoxStyle}
// //               >
// //                 <CalendarTodayIcon fontSize="small" sx={{ color: "#6b7280" }} />
// //                 <SoftTypography sx={dateTextStyle}>
// //                   {filters.to
// //                     ? dayjs(filters.to).format("DD-MMM-YYYY")
// //                     : "To Date"}
// //                 </SoftTypography>
// //               </SoftBox>
// //             </div>

// //             {/* LEAVE TYPE (DYNAMIC) */}
// //             <div className="col-md-3">
// //               <SoftSelect
// //                 label="Leave Type"
// //                 isDisabled={leaveLoading}
// //                 value={getSelected("leave_policy_id", leaveTypeOptions)}
// //                 options={leaveTypeOptions}
// //                 onChange={({ value }) =>
// //                   onFilterChange("leave_policy_id", value)
// //                 }
// //               />
// //             </div>
// //           </>
// //         )}

// //         {/* SEARCH */}
// //         <div className="col-md-3 ms-auto">
// //           <SoftInput
// //             label="Search"
// //             placeholder="Search by name or email"
// //             value={searchTerm}
// //             onChange={(e) => onSearchChange(e.target.value)}
// //           />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // /* ---------------- STYLES ---------------- */
// // const dateBoxStyle = {
// //   border: "1px solid #d1d5db",
// //   borderRadius: "6px",
// //   px: 1.2,
// //   py: 1,
// //   cursor: "pointer",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: 0.8,
// //   minHeight: "36px",
// //   background: "white",
// // };

// // const dateTextStyle = {
// //   fontSize: "0.75rem",
// //   color: "#6b7280",
// //   fontWeight: 400,
// // };

// // UserFilters.propTypes = {
// //   filters: PropTypes.object.isRequired,
// //   onFilterChange: PropTypes.func.isRequired,
// //   searchTerm: PropTypes.string.isRequired,
// //   onSearchChange: PropTypes.func.isRequired,
// //   dropdownOptions: PropTypes.object.isRequired,
// //   fetchShiftsForBranch: PropTypes.func.isRequired,
// //   showHistoryFilters: PropTypes.bool,
// // };

// // export default UserFilters;

// // import React, { useEffect, useState } from "react";
// // import PropTypes from "prop-types";
// // import dayjs from "dayjs";

// // import SoftInput from "components/SoftInput";
// // import SoftSelect from "components/SoftSelect";
// // import SoftBox from "components/SoftBox";
// // import SoftTypography from "components/SoftTypography";

// // import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// // // 🔹 API
// // import { usersVisibleLeavePolicy } from "api/users";
// // import { getLeavePolicies } from "api/leave";

// // const UserFilters = ({
// //   filters,
// //   onFilterChange,
// //   searchTerm,
// //   onSearchChange,
// //   dropdownOptions,
// //   fetchShiftsForBranch,
// //   showHistoryFilters = false,
// // }) => {
// //   /* ======================================================
// //      BRANCH → SHIFT DEPENDENCY
// //   ====================================================== */
// //   useEffect(() => {
// //     if (filters.branch_id) {
// //       fetchShiftsForBranch(filters.branch_id);
// //     } else {
// //       fetchShiftsForBranch(null);
// //     }
// //   }, [filters.branch_id, fetchShiftsForBranch]);

// //   /* ======================================================
// //      LEAVE TYPE (DYNAMIC FROM API)
// //   ====================================================== */
// //   const [leaveTypeOptions, setLeaveTypeOptions] = useState([
// //     { value: "", label: "All Leave Types" },
// //   ]);
// //   const [leaveLoading, setLeaveLoading] = useState(false);

// //   useEffect(() => {
// //     if (!showHistoryFilters) return;

// //     const fetchLeaveTypes = async () => {
// //       try {
// //         setLeaveLoading(true);

// //         const res = await getLeavePolicies();
// //         const list = Array.isArray(res?.data)
// //           ? res.data
// //           : res?.data?.data || [];

// //         const options = [
// //           { value: "", label: "All Leave Types" },
// //           ...list.map((p) => ({
// //             value: String(p.id),
// //             label: `${p.leave_name} (${p.leave_code})`,
// //           })),
// //         ];

// //         setLeaveTypeOptions(options);
// //       } catch (err) {
// //         console.error("Leave type load failed", err);
// //         setLeaveTypeOptions([{ value: "", label: "All Leave Types" }]);
// //       } finally {
// //         setLeaveLoading(false);
// //       }
// //     };

// //     fetchLeaveTypes();
// //   }, [showHistoryFilters]);

// //   /* ======================================================
// //      HELPERS
// //   ====================================================== */
// //   const getSelected = (key, options) =>
// //     options.find((o) => String(o.value) === String(filters[key])) || options[0];

// //   /* ======================================================
// //      JSX
// //   ====================================================== */
// //   return (
// //     <div className="container-fluid">
// //       {/* =================================================
// //           ROW 1 → COMMON FILTERS
// //       ================================================= */}
// //       <div className="row g-3 align-items-end">
// //         <div className="col-md">
// //           <SoftSelect
// //             label="Branch"
// //             value={getSelected("branch_id", [
// //               { value: "", label: "All Branches" },
// //               ...dropdownOptions.branches.map((b) => ({
// //                 value: String(b.id),
// //                 label: b.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => {
// //               onFilterChange("branch_id", value);
// //               onFilterChange("shift_id", "");
// //             }}
// //             options={[
// //               { value: "", label: "All Branches" },
// //               ...dropdownOptions.branches.map((b) => ({
// //                 value: String(b.id),
// //                 label: b.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Shift"
// //             isDisabled={!filters.branch_id}
// //             value={getSelected("shift_id", [
// //               { value: "", label: "All Shifts" },
// //               ...(filters.branch_id
// //                 ? dropdownOptions.shifts.map((s) => ({
// //                     value: String(s.id),
// //                     label: s.label,
// //                   }))
// //                 : []),
// //             ])}
// //             onChange={({ value }) => onFilterChange("shift_id", value)}
// //             options={[
// //               {
// //                 value: "",
// //                 label: filters.branch_id
// //                   ? "All Shifts"
// //                   : "Choose branch first",
// //               },
// //               ...(filters.branch_id
// //                 ? dropdownOptions.shifts.map((s) => ({
// //                     value: String(s.id),
// //                     label: s.label,
// //                   }))
// //                 : []),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Department"
// //             value={getSelected("department_id", [
// //               { value: "", label: "All Departments" },
// //               ...dropdownOptions.departments.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => onFilterChange("department_id", value)}
// //             options={[
// //               { value: "", label: "All Departments" },
// //               ...dropdownOptions.departments.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Designation"
// //             value={getSelected("designation_id", [
// //               { value: "", label: "All Designations" },
// //               ...dropdownOptions.designations.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ])}
// //             onChange={({ value }) => onFilterChange("designation_id", value)}
// //             options={[
// //               { value: "", label: "All Designations" },
// //               ...dropdownOptions.designations.map((d) => ({
// //                 value: String(d.id),
// //                 label: d.name,
// //               })),
// //             ]}
// //           />
// //         </div>

// //         <div className="col-md">
// //           <SoftSelect
// //             label="Role"
// //             value={getSelected("role", [
// //               { value: "", label: "All Roles" },
// //               { value: "Admin", label: "Admin" },
// //               { value: "HR", label: "HR" },
// //               { value: "Manager", label: "Manager" },
// //               { value: "Team Leader", label: "Team Leader" },
// //               { value: "User", label: "User" },
// //             ])}
// //             onChange={({ value }) => onFilterChange("role", value)}
// //             options={[
// //               { value: "", label: "All Roles" },
// //               { value: "Admin", label: "Admin" },
// //               { value: "HR", label: "HR" },
// //               { value: "Manager", label: "Manager" },
// //               { value: "Team Leader", label: "Team Leader" },
// //               { value: "User", label: "User" },
// //             ]}
// //           />
// //         </div>
// //       </div>

// //       {/* =================================================
// //           ROW 2 → HISTORY FILTERS
// //       ================================================= */}
// //       <div className="row g-3 mt-3 align-items-end">
// //         {showHistoryFilters && (
// //           <>
// //             {/* FROM DATE */}
// //             <div className="col-md-3">
// //               <SoftBox
// //                 onClick={(e) => onFilterChange("__open_from__", e.currentTarget)}
// //                 sx={dateBoxStyle}
// //               >
// //                 <CalendarTodayIcon fontSize="small" sx={{ color: "#6b7280" }} />
// //                 <SoftTypography sx={dateTextStyle}>
// //                   {filters.from
// //                     ? dayjs(filters.from).format("DD-MMM-YYYY")
// //                     : "From Date"}
// //                 </SoftTypography>
// //               </SoftBox>
// //             </div>

// //             {/* TO DATE */}
// //             <div className="col-md-3">
// //               <SoftBox
// //                 onClick={(e) => onFilterChange("__open_to__", e.currentTarget)}
// //                 sx={dateBoxStyle}
// //               >
// //                 <CalendarTodayIcon fontSize="small" sx={{ color: "#6b7280" }} />
// //                 <SoftTypography sx={dateTextStyle}>
// //                   {filters.to
// //                     ? dayjs(filters.to).format("DD-MMM-YYYY")
// //                     : "To Date"}
// //                 </SoftTypography>
// //               </SoftBox>
// //             </div>

// //             {/* LEAVE TYPE */}
// //             <div className="col-md-3">
// //               <SoftSelect
// //                 label="Leave Type"
// //                 isDisabled={leaveLoading}
// //                 value={getSelected("leave_policy_id", leaveTypeOptions)}
// //                 options={leaveTypeOptions}
// //                 onChange={({ value }) =>
// //                   onFilterChange("leave_policy_id", value)
// //                 }
// //               />
// //             </div>
// //           </>
// //         )}

// //         {/* SEARCH */}
// //         <div className="col-md-3 ms-auto">
// //           <SoftInput
// //             label="Search"
// //             placeholder="Search by name or email"
// //             value={searchTerm}
// //             onChange={(e) => onSearchChange(e.target.value)}
// //           />
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // /* ======================================================
// //    STYLES
// // ====================================================== */
// // const dateBoxStyle = {
// //   border: "1px solid #d1d5db",
// //   borderRadius: "6px",
// //        backgroundColor: "#ffffff",   // ✅ solid white
// //       color: "#111827",
// //   px: 1.2,
// //   py: 1.2,
// //   cursor: "pointer",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: 0.8,
// //   minHeight: "36px",
// //   background: "white",
// // };

// // const dateTextStyle = {
// //   fontSize: "0.75rem",
// //   color: "#6b7280",
// //   fontWeight: 400,
// // };

// // UserFilters.propTypes = {
// //   filters: PropTypes.object.isRequired,
// //   onFilterChange: PropTypes.func.isRequired,
// //   searchTerm: PropTypes.string.isRequired,
// //   onSearchChange: PropTypes.func.isRequired,
// //   dropdownOptions: PropTypes.object.isRequired,
// //   fetchShiftsForBranch: PropTypes.func.isRequired,
// //   showHistoryFilters: PropTypes.bool,
// // };

// // export default UserFilters;

// // import React, { useEffect, useState } from "react";
// // import PropTypes from "prop-types";
// // import dayjs from "dayjs";

// // import SoftInput from "components/SoftInput";
// // import SoftSelect from "components/SoftSelect";
// // import SoftBox from "components/SoftBox";
// // import SoftTypography from "components/SoftTypography";

// // import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// // // 🔹 API
// // import { getLeavePolicies } from "api/leave";

// // // 🔐 AUTH
// // import { useAuth } from "AuthContext";

// // const UserFilters = ({
// //   filters,
// //   onFilterChange,
// //   searchTerm,
// //   onSearchChange,
// //   dropdownOptions,
// //   fetchShiftsForBranch,
// //   showHistoryFilters = false,

// //   // 🔑 PERMISSION BASE
// //   permissionBase = "Attendance.Team",
// // }) => {
// //   const { userPermission = [] } = useAuth();

// //   /* ================= PERMISSION HELPERS ================= */
// //   const hasPermission = (perm) => userPermission.includes(perm);

// //   const can = (suffix) => hasPermission(`${permissionBase}.${suffix}`);

// //   /* ================= BRANCH → SHIFT ================= */
// //   useEffect(() => {
// //     if (filters.branch_id) fetchShiftsForBranch(filters.branch_id);
// //     else fetchShiftsForBranch(null);
// //   }, [filters.branch_id, fetchShiftsForBranch]);

// //   /* ================= LEAVE TYPE ================= */
// //   const [leaveTypeOptions, setLeaveTypeOptions] = useState([
// //     { value: "", label: "All Leave Types" },
// //   ]);
// //   const [leaveLoading, setLeaveLoading] = useState(false);

// //   useEffect(() => {
// //     if (!showHistoryFilters) return;

// //     const fetchLeaveTypes = async () => {
// //       try {
// //         setLeaveLoading(true);
// //         const res = await getLeavePolicies();
// //         const list = res?.data?.data || res?.data || [];

// //         setLeaveTypeOptions([
// //           { value: "", label: "All Leave Types" },
// //           ...list.map((p) => ({
// //             value: String(p.id),
// //             label: `${p.leave_name} (${p.leave_code})`,
// //           })),
// //         ]);
// //       } catch (e) {
// //         console.error("Leave type load failed", e);
// //         setLeaveTypeOptions([{ value: "", label: "All Leave Types" }]);
// //       } finally {
// //         setLeaveLoading(false);
// //       }
// //     };

// //     fetchLeaveTypes();
// //   }, [showHistoryFilters]);

// //   /* ================= HELPERS ================= */
// //   const getSelected = (key, options) =>
// //     options.find((o) => String(o.value) === String(filters[key])) || options[0];

// //   /* ================= JSX ================= */
// //   return (
// //     <div className="container-fluid">
// //       {/* ================= ROW 1 ================= */}
// //       <div className="row g-3 align-items-end">
// //         {can("BranchFilter") && (
// //           <div className="col-md">
// //             <SoftSelect
// //               label="Branch"
// //               value={getSelected("branch_id", [
// //                 { value: "", label: "All Branches" },
// //                 ...dropdownOptions.branches.map((b) => ({
// //                   value: String(b.id),
// //                   label: b.name,
// //                 })),
// //               ])}
// //               onChange={({ value }) => {
// //                 onFilterChange("branch_id", value);
// //                 onFilterChange("shift_id", "");
// //               }}
// //               options={[
// //                 { value: "", label: "All Branches" },
// //                 ...dropdownOptions.branches.map((b) => ({
// //                   value: String(b.id),
// //                   label: b.name,
// //                 })),
// //               ]}
// //             />
// //           </div>
// //         )}

// //         {can("ShiftFilter") && (
// //           <div className="col-md">
// //             <SoftSelect
// //               label="Shift"
// //               isDisabled={!filters.branch_id}
// //               value={getSelected("shift_id", [
// //                 { value: "", label: "All Shifts" },
// //                 ...dropdownOptions.shifts.map((s) => ({
// //                   value: String(s.id),
// //                   label: s.label,
// //                 })),
// //               ])}
// //               onChange={({ value }) => onFilterChange("shift_id", value)}
// //               options={[
// //                 {
// //                   value: "",
// //                   label: filters.branch_id
// //                     ? "All Shifts"
// //                     : "Choose branch first",
// //                 },
// //                 ...dropdownOptions.shifts.map((s) => ({
// //                   value: String(s.id),
// //                   label: s.label,
// //                 })),
// //               ]}
// //             />
// //           </div>
// //         )}

// //         {can("DepartmentFilter") && (
// //           <div className="col-md">
// //             <SoftSelect
// //               label="Department"
// //               value={getSelected("department_id", [
// //                 { value: "", label: "All Departments" },
// //                 ...dropdownOptions.departments.map((d) => ({
// //                   value: String(d.id),
// //                   label: d.name,
// //                 })),
// //               ])}
// //               onChange={({ value }) => onFilterChange("department_id", value)}
// //               options={[
// //                 { value: "", label: "All Departments" },
// //                 ...dropdownOptions.departments.map((d) => ({
// //                   value: String(d.id),
// //                   label: d.name,
// //                 })),
// //               ]}
// //             />
// //           </div>
// //         )}

// //         {can("DesignationFilter") && (
// //           <div className="col-md">
// //             <SoftSelect
// //               label="Designation"
// //               value={getSelected("designation_id", [
// //                 { value: "", label: "All Designations" },
// //                 ...dropdownOptions.designations.map((d) => ({
// //                   value: String(d.id),
// //                   label: d.name,
// //                 })),
// //               ])}
// //               onChange={({ value }) => onFilterChange("designation_id", value)}
// //               options={[
// //                 { value: "", label: "All Designations" },
// //                 ...dropdownOptions.designations.map((d) => ({
// //                   value: String(d.id),
// //                   label: d.name,
// //                 })),
// //               ]}
// //             />
// //           </div>
// //         )}

// //         {can("RoleFilter") && (
// //           <div className="col-md">
// //             <SoftSelect
// //               label="Role"
// //               value={getSelected("role", [
// //                 { value: "", label: "All Roles" },
// //                 { value: "Admin", label: "Admin" },
// //                 { value: "HR", label: "HR" },
// //                 { value: "Manager", label: "Manager" },
// //                 { value: "Team Leader", label: "Team Leader" },
// //                 { value: "User", label: "User" },
// //               ])}
// //               onChange={({ value }) => onFilterChange("role", value)}
// //               options={[
// //                 { value: "", label: "All Roles" },
// //                 { value: "Admin", label: "Admin" },
// //                 { value: "HR", label: "HR" },
// //                 { value: "Manager", label: "Manager" },
// //                 { value: "Team Leader", label: "Team Leader" },
// //                 { value: "User", label: "User" },
// //               ]}
// //             />
// //           </div>
// //         )}
// //       </div>

// //       {/* ================= ROW 2 ================= */}
// //       <div className="row g-3 mt-3 align-items-end">
// //         {showHistoryFilters && (
// //           <>
// //             {can("FromDateFilter") && (
// //               <div className="col-md-3">
// //                 <SoftBox
// //                   onClick={(e) =>
// //                     onFilterChange("__open_from__", e.currentTarget)
// //                   }
// //                   sx={dateBoxStyle}
// //                 >
// //                   <CalendarTodayIcon fontSize="small" sx={{ color: "#6b7280" }} />
// //                   <SoftTypography sx={dateTextStyle}>
// //                     {filters.from
// //                       ? dayjs(filters.from).format("DD-MMM-YYYY")
// //                       : "From Date"}
// //                   </SoftTypography>
// //                 </SoftBox>
// //               </div>
// //             )}

// //             {can("ToDateFilter") && (
// //               <div className="col-md-3">
// //                 <SoftBox
// //                   onClick={(e) =>
// //                     onFilterChange("__open_to__", e.currentTarget)
// //                   }
// //                   sx={dateBoxStyle}
// //                 >
// //                   <CalendarTodayIcon fontSize="small" sx={{ color: "#6b7280" }} />
// //                   <SoftTypography sx={dateTextStyle}>
// //                     {filters.to
// //                       ? dayjs(filters.to).format("DD-MMM-YYYY")
// //                       : "To Date"}
// //                   </SoftTypography>
// //                 </SoftBox>
// //               </div>
// //             )}
// //           </>
// //         )}

// //         {can("SearchFilter") && (
// //           <div className="col-md-3 ms-auto">
// //             <SoftInput
// //               label="Search"
// //               placeholder="Search by name or email"
// //               value={searchTerm}
// //               onChange={(e) => onSearchChange(e.target.value)}
// //             />
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // /* ================= STYLES ================= */
// // const dateBoxStyle = {
// //   border: "1px solid #d1d5db",
// //   borderRadius: "6px",
// //   backgroundColor: "#ffffff",
// //   px: 1.2,
// //   py: 1.2,
// //   cursor: "pointer",
// //   display: "flex",
// //   alignItems: "center",
// //   gap: 0.8,
// //   minHeight: "36px",
// // };

// // const dateTextStyle = {
// //   fontSize: "0.75rem",
// //   color: "#6b7280",
// // };

// // UserFilters.propTypes = {
// //   filters: PropTypes.object.isRequired,
// //   onFilterChange: PropTypes.func.isRequired,
// //   searchTerm: PropTypes.string.isRequired,
// //   onSearchChange: PropTypes.func.isRequired,
// //   dropdownOptions: PropTypes.object.isRequired,
// //   fetchShiftsForBranch: PropTypes.func.isRequired,
// //   showHistoryFilters: PropTypes.bool,
// //   permissionBase: PropTypes.string,
// // };

// // export default UserFilters;

// /* eslint-disable react/prop-types */
// import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
// import dayjs from "dayjs";

// import SoftInput from "components/SoftInput";
// import SoftSelect from "components/SoftSelect";
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";

// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

// // 🔹 API
// import { getLeavePolicies } from "api/leave";

// // 🔐 AUTH
// import { useAuth } from "AuthContext";

// /* ======================================================
//    COMPONENT
// ====================================================== */
// const UserFilters = ({
//   filters,
//   onFilterChange,
//   searchTerm,
//   onSearchChange,
//   dropdownOptions,
//   fetchShiftsForBranch,
//   showHistoryFilters = false,
// }) => {
//   const { userPermission } = useAuth();

//   /* ======================================================
//      DYNAMIC PERMISSION CHECK
//   ====================================================== */
//   const canShow = (permSuffix) =>
//     Array.isArray(userPermission) &&
//     userPermission.some((p) => p.endsWith(permSuffix));

//   /* ======================================================
//      BRANCH → SHIFT DEPENDENCY
//   ====================================================== */
//   useEffect(() => {
//     if (filters.branch_id) {
//       fetchShiftsForBranch(filters.branch_id);
//     } else {
//       fetchShiftsForBranch(null);
//     }
//   }, [filters.branch_id, fetchShiftsForBranch]);

//   /* ======================================================
//      LEAVE TYPE (HISTORY)
//   ====================================================== */
//   const [leaveTypeOptions, setLeaveTypeOptions] = useState([
//     { value: "", label: "All Leave Types" },
//   ]);
//   const [leaveLoading, setLeaveLoading] = useState(false);

//   useEffect(() => {
//     if (!showHistoryFilters) return;

//     const fetchLeaveTypes = async () => {
//       try {
//         setLeaveLoading(true);
//         const res = await getLeavePolicies();
//         const list = Array.isArray(res?.data)
//           ? res.data
//           : res?.data?.data || [];

//         setLeaveTypeOptions([
//           { value: "", label: "All Leave Types" },
//           ...list.map((p) => ({
//             value: String(p.id),
//             label: `${p.leave_name} (${p.leave_code})`,
//           })),
//         ]);
//       } catch (err) {
//         console.error("Leave type load failed", err);
//       } finally {
//         setLeaveLoading(false);
//       }
//     };

//     fetchLeaveTypes();
//   }, [showHistoryFilters]);

//   /* ======================================================
//      HELPERS
//   ====================================================== */
//   const getSelected = (key, options) =>
//     options.find((o) => String(o.value) === String(filters[key])) || options[0];

//   /* ======================================================
//      JSX
//   ====================================================== */
//   return (
//     <div className="container-fluid">
//       {/* ================= ROW 1 ================= */}
//       <div className="row g-3 align-items-end">
//         {/* BRANCH */}
//         {canShow("BranchFilter") && (
//           <div className="col-md">
//             <SoftSelect
//               label="Branch"
//               value={getSelected("branch_id", [
//                 { value: "", label: "All Branches" },
//                 ...dropdownOptions.branches.map((b) => ({
//                   value: String(b.id),
//                   label: b.name,
//                 })),
//               ])}
//               onChange={({ value }) => {
//                 onFilterChange("branch_id", value);
//                 onFilterChange("shift_id", "");
//               }}
//               options={[
//                 { value: "", label: "All Branches" },
//                 ...dropdownOptions.branches.map((b) => ({
//                   value: String(b.id),
//                   label: b.name,
//                 })),
//               ]}
//             />
//           </div>
//         )}

//         {/* SHIFT */}
//         {canShow("ShiftFilter") && (
//           <div className="col-md">
//             <SoftSelect
//               label="Shift"
//               isDisabled={!filters.branch_id}
//               value={getSelected("shift_id", [
//                 { value: "", label: "All Shifts" },
//                 ...(filters.branch_id
//                   ? dropdownOptions.shifts.map((s) => ({
//                       value: String(s.id),
//                       label: s.label,
//                     }))
//                   : []),
//               ])}
//               onChange={({ value }) => onFilterChange("shift_id", value)}
//               options={[
//                 {
//                   value: "",
//                   label: filters.branch_id
//                     ? "All Shifts"
//                     : "Choose branch first",
//                 },
//                 ...(filters.branch_id
//                   ? dropdownOptions.shifts.map((s) => ({
//                       value: String(s.id),
//                       label: s.label,
//                     }))
//                   : []),
//               ]}
//             />
//           </div>
//         )}

//         {/* DEPARTMENT */}
//         {canShow("DepartmentFilter") && (
//           <div className="col-md">
//             <SoftSelect
//               label="Department"
//               value={getSelected("department_id", [
//                 { value: "", label: "All Departments" },
//                 ...dropdownOptions.departments.map((d) => ({
//                   value: String(d.id),
//                   label: d.name,
//                 })),
//               ])}
//               onChange={({ value }) => onFilterChange("department_id", value)}
//               options={[
//                 { value: "", label: "All Departments" },
//                 ...dropdownOptions.departments.map((d) => ({
//                   value: String(d.id),
//                   label: d.name,
//                 })),
//               ]}
//             />
//           </div>
//         )}

//         {/* DESIGNATION */}
//         {canShow("DesignationFilter") && (
//           <div className="col-md">
//             <SoftSelect
//               label="Designation"
//               value={getSelected("designation_id", [
//                 { value: "", label: "All Designations" },
//                 ...dropdownOptions.designations.map((d) => ({
//                   value: String(d.id),
//                   label: d.name,
//                 })),
//               ])}
//               onChange={({ value }) =>
//                 onFilterChange("designation_id", value)
//               }
//               options={[
//                 { value: "", label: "All Designations" },
//                 ...dropdownOptions.designations.map((d) => ({
//                   value: String(d.id),
//                   label: d.name,
//                 })),
//               ]}
//             />
//           </div>
//         )}

//         {/* ROLE */}
//         {canShow("RoleFilter") && (
//           <div className="col-md">
//             <SoftSelect
//               label="Role"
//               value={getSelected("role", [
//                 { value: "", label: "All Roles" },
//                 { value: "Admin", label: "Admin" },
//                 { value: "HR", label: "HR" },
//                 { value: "Manager", label: "Manager" },
//                 { value: "Team Leader", label: "Team Leader" },
//                 { value: "User", label: "User" },
//               ])}
//               onChange={({ value }) => onFilterChange("role", value)}
//               options={[
//                 { value: "", label: "All Roles" },
//                 { value: "Admin", label: "Admin" },
//                 { value: "HR", label: "HR" },
//                 { value: "Manager", label: "Manager" },
//                 { value: "Team Leader", label: "Team Leader" },
//                 { value: "User", label: "User" },
//               ]}
//             />
//           </div>
//         )}
//       </div>

//       {/* ================= ROW 2 ================= */}
//       <div className="row g-3 mt-3 align-items-end">
//         {showHistoryFilters && (
//           <>
//             {canShow("FromDateFilter") && (
//               <div className="col-md-3">
//                 <SoftBox
//                   onClick={(e) =>
//                     onFilterChange("__open_from__", e.currentTarget)
//                   }
//                   sx={dateBoxStyle}
//                 >
//                   <CalendarTodayIcon fontSize="small" />
//                   <SoftTypography sx={dateTextStyle}>
//                     {filters.from
//                       ? dayjs(filters.from).format("DD-MMM-YYYY")
//                       : "From Date"}
//                   </SoftTypography>
//                 </SoftBox>
//               </div>
//             )}

//             {canShow("ToDateFilter") && (
//               <div className="col-md-3">
//                 <SoftBox
//                   onClick={(e) =>
//                     onFilterChange("__open_to__", e.currentTarget)
//                   }
//                   sx={dateBoxStyle}
//                 >
//                   <CalendarTodayIcon fontSize="small" />
//                   <SoftTypography sx={dateTextStyle}>
//                     {filters.to
//                       ? dayjs(filters.to).format("DD-MMM-YYYY")
//                       : "To Date"}
//                   </SoftTypography>
//                 </SoftBox>
//               </div>
//             )}
//           </>
//         )}

//         {/* SEARCH */}
//         {canShow("SearchFilter") && (
//           <div className="col-md-3 ms-auto">
//             <SoftInput
//               label="Search"
//               placeholder="Search by name or email"
//               value={searchTerm}
//               onChange={(e) => onSearchChange(e.target.value)}
//             />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// /* ======================================================
//    STYLES
// ====================================================== */
// const dateBoxStyle = {
//   border: "1px solid #d1d5db",
//   borderRadius: "6px",
//   backgroundColor: "#ffffff",
//   px: 1.2,
//   py: 1.2,
//   cursor: "pointer",
//   display: "flex",
//   alignItems: "center",
//   gap: 0.8,
//   minHeight: "36px",
// };

// const dateTextStyle = {
//   fontSize: "0.75rem",
//   color: "#6b7280",
// };

// /* ======================================================
//    PROPS
// ====================================================== */
// UserFilters.propTypes = {
//   filters: PropTypes.object.isRequired,
//   onFilterChange: PropTypes.func.isRequired,
//   searchTerm: PropTypes.string.isRequired,
//   onSearchChange: PropTypes.func.isRequired,
//   dropdownOptions: PropTypes.object.isRequired,
//   fetchShiftsForBranch: PropTypes.func.isRequired,
//   showHistoryFilters: PropTypes.bool,
// };

// export default UserFilters;

/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { calendarSx, dateInputBoxSx, dateInputTextSx } from "assets/theme/commonCalendarSx";
import SoftInput from "components/SoftInput";
import SoftSelect from "components/SoftSelect";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Popover from "@mui/material/Popover";

import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CloseIcon from "@mui/icons-material/Close";
// 🔹 API
import { getLeavePolicies } from "api/leave";

// 🔐 AUTH
import { useAuth } from "AuthContext";

/* ======================================================
   COMPONENT
====================================================== */
const UserFilters = ({
  filters,
  onFilterChange,
  searchTerm,
  onSearchChange,
  dropdownOptions,
  fetchShiftsForBranch,
  showHistoryFilters = false,
}) => {
  const { userPermission } = useAuth();

  /* ================= PERMISSION ================= */
  // const canShow = (permSuffix) =>
  //   Array.isArray(userPermission) && userPermission.some((p) => p.endsWith(permSuffix));

const canShow = (permSuffix) => {
  if (!Array.isArray(userPermission)) return false;

  return userPermission.some((p) => {
    // ✅ Exact suffix match (Attendance + old modules)
    if (p.endsWith(`.${permSuffix}`)) return true;

    // ✅ Old system compatibility (JUST IN CASE)
    if (p === permSuffix) return true;

    return false;
  });
};



  /* ================= BRANCH → SHIFT ================= */
  useEffect(() => {
    if (filters.branch_id) {
      fetchShiftsForBranch(filters.branch_id);
    } else {
      fetchShiftsForBranch(null);
    }
  }, [filters.branch_id, fetchShiftsForBranch]);

  /* ================= LEAVE TYPES (HISTORY) ================= */
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([
    { value: "", label: "All Leave Types" },
  ]);

  useEffect(() => {
    if (!showHistoryFilters) return;

    const fetchLeaveTypes = async () => {
      try {
        const res = await getLeavePolicies();
        const list = Array.isArray(res?.data) ? res.data : res?.data?.data || [];

        setLeaveTypeOptions([
          { value: "", label: "All Leave Types" },
          ...list.map((p) => ({
            value: String(p.id),
            label: `${p.leave_name} (${p.leave_code})`,
          })),
        ]);
      } catch (err) {
        console.error("Leave type load failed", err);
      }
    };

    fetchLeaveTypes();
  }, [showHistoryFilters]);

  /* ================= DATE PICKER STATE ================= */
  const [fromAnchor, setFromAnchor] = useState(null);
  const [toAnchor, setToAnchor] = useState(null);

  /* ================= HELPERS ================= */
  const getSelected = (key, options) =>
    options.find((o) => String(o.value) === String(filters[key])) || options[0];

  /* ======================================================
     JSX
  ====================================================== */
  return (
    <div className="container-fluid">
      {/* ================= ROW 1 ================= */}
      <div className="row g-3 align-items-end">
        {/* BRANCH */}
        {canShow("BranchFilter") && (
          <div className="col-md">
            <SoftSelect
              label="Branch"
              value={getSelected("branch_id", [
                { value: "", label: "All Branches" },
                ...dropdownOptions.branches.map((b) => ({
                  value: String(b.id),
                  label: b.name,
                })),
              ])}
              onChange={({ value }) => {
                onFilterChange("branch_id", value);
                onFilterChange("shift_id", "");
              }}
              options={[
                { value: "", label: "All Branches" },
                ...dropdownOptions.branches.map((b) => ({
                  value: String(b.id),
                  label: b.name,
                })),
              ]}
            />
          </div>
        )}

        {/* SHIFT */}
        {canShow("ShiftFilter") && (
          <div className="col-md">
            <SoftSelect
              label="Shift"
              isDisabled={!filters.branch_id}
              value={getSelected("shift_id", [
                { value: "", label: "All Shifts" },
                ...(filters.branch_id
                  ? dropdownOptions.shifts.map((s) => ({
                      value: String(s.id),
                      label: s.label,
                    }))
                  : []),
              ])}
              onChange={({ value }) => onFilterChange("shift_id", value)}
              options={[
                {
                  value: "",
                  label: filters.branch_id ? "All Shifts" : "Choose branch first",
                },
                ...(filters.branch_id
                  ? dropdownOptions.shifts.map((s) => ({
                      value: String(s.id),
                      label: s.label,
                    }))
                  : []),
              ]}
            />
          </div>
        )}

        {/* DEPARTMENT */}
        {canShow("DepartmentFilter") && (
          <div className="col-md">
            <SoftSelect
              label="Department"
              value={getSelected("department_id", [
                { value: "", label: "All Departments" },
                ...dropdownOptions.departments.map((d) => ({
                  value: String(d.id),
                  label: d.name,
                })),
              ])}
              onChange={({ value }) => onFilterChange("department_id", value)}
              options={[
                { value: "", label: "All Departments" },
                ...dropdownOptions.departments.map((d) => ({
                  value: String(d.id),
                  label: d.name,
                })),
              ]}
            />
          </div>
        )}

        {/* DESIGNATION */}
        {canShow("DesignationFilter") && (
          <div className="col-md">
            <SoftSelect
              label="Designation"
              value={getSelected("designation_id", [
                { value: "", label: "All Designations" },
                ...dropdownOptions.designations.map((d) => ({
                  value: String(d.id),
                  label: d.name,
                })),
              ])}
              onChange={({ value }) => onFilterChange("designation_id", value)}
              options={[
                { value: "", label: "All Designations" },
                ...dropdownOptions.designations.map((d) => ({
                  value: String(d.id),
                  label: d.name,
                })),
              ]}
            />
          </div>
        )}

        {/* ROLE */}
        {canShow("RoleFilter") && (
          <div className="col-md">
            <SoftSelect
              label="Role"
              value={getSelected("role", [
                { value: "", label: "All Roles" },
                { value: "Admin", label: "Admin" },
                { value: "HR", label: "HR" },
                { value: "Manager", label: "Manager" },
                { value: "Team Leader", label: "Team Leader" },
                { value: "User", label: "User" },
              ])}
              onChange={({ value }) => onFilterChange("role", value)}
              options={[
                { value: "", label: "All Roles" },
                { value: "Admin", label: "Admin" },
                { value: "HR", label: "HR" },
                { value: "Manager", label: "Manager" },
                { value: "Team Leader", label: "Team Leader" },
                { value: "User", label: "User" },
              ]}
            />
          </div>
        )}

        {/* SEARCH */}
        {canShow("SearchFilter") && (
          <div className="col-md-2">
            <SoftInput
              label="Search"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        )}
      </div>

      {/* ================= ROW 2 ================= */}
      <div className="row g-3 align-items-end" style={{ marginTop: "0.1px" }}>
        {showHistoryFilters && (
          <>
            {/* FROM DATE */}
            {/* {canShow("FromDateFilter") && (
              <div className="col-md-3">
                <SoftBox sx={dateInputBoxSx} onClick={(e) => setFromAnchor(e.currentTarget)}>
                  <CalendarTodayIcon fontSize="small" />
                  <SoftTypography sx={dateInputTextSx}>
                    {filters.from ? dayjs(filters.from).format("DD-MMM-YYYY") : "From Date"}
                  </SoftTypography>
                </SoftBox>
              </div>
            )} */}

            {canShow("FromDateFilter") && (
              <div className="col-md-2">
                <SoftBox sx={dateInputBoxSx} onClick={(e) => setFromAnchor(e.currentTarget)}>
                  <CalendarTodayIcon fontSize="small" />

                  <SoftTypography sx={{ ...dateInputTextSx, flexGrow: 1 }}>
                    {filters.from ? dayjs(filters.from).format("DD-MMM-YYYY") : "From Date"}
                  </SoftTypography>

                  {filters.from && (
                    <CloseIcon
                      fontSize="small"
                      sx={{ cursor: "pointer", color: "#9ca3af" }}
                      onClick={(e) => {
                        e.stopPropagation(); // ❌ calendar open nahi hoga
                        onFilterChange("from", null); // ✅ DATE CLEAR
                        setFromAnchor(null);
                      }}
                    />
                  )}
                </SoftBox>
              </div>
            )}

            {/* TO DATE */}
            {/* {canShow("ToDateFilter") && (
              <div className="col-md-3">
                <SoftBox sx={dateInputBoxSx} onClick={(e) => setToAnchor(e.currentTarget)}>
                  <CalendarTodayIcon fontSize="small" />
                  <SoftTypography sx={dateInputTextSx}>
                    {filters.to ? dayjs(filters.to).format("DD-MMM-YYYY") : "To Date"}
                  </SoftTypography>
                </SoftBox>
              </div>
            )} */}

            {canShow("ToDateFilter") && (
              <div className="col-md-2">
                <SoftBox sx={dateInputBoxSx} onClick={(e) => setToAnchor(e.currentTarget)}>
                  <CalendarTodayIcon fontSize="small" />

                  <SoftTypography sx={{ ...dateInputTextSx, flexGrow: 1 }}>
                    {filters.to ? dayjs(filters.to).format("DD-MMM-YYYY") : "To Date"}
                  </SoftTypography>

                  {filters.to && (
                    <CloseIcon
                      fontSize="small"
                      sx={{ cursor: "pointer", color: "#9ca3af" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onFilterChange("to", null); // ✅ DATE CLEAR
                        setToAnchor(null);
                      }}
                    />
                  )}
                </SoftBox>
              </div>
            )}

            {/* ================= ROW 3 : STATUS FILTER ================= */}

              {canShow("StatusFilter") && (
              <div className="col-md-2">
                <SoftSelect
                  label="Status"
                  value={{
                    value: filters.status || "",
                    label:
                      filters.status === "approved"
                        ? "Approved"
                        : filters.status === "pending"
                        ? "Pending"
                        : filters.status === "rejected"
                        ? "Rejected"
                        : "All Status",
                  }}
                  onChange={({ value }) => onFilterChange("status", value)}
                  options={[
                    { value: "", label: "All Status" },
                    { value: "approved", label: "Approved" },
                    { value: "pending", label: "Pending" },
                    { value: "rejected", label: "Rejected" },
                  ]}
                />
              </div>
              )}
          </>
        )}
      </div>

      {/* ================= FROM CALENDAR ================= */}
      {/* <Popover
        open={Boolean(fromAnchor)}
        anchorEl={fromAnchor}
        onClose={() => setFromAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            boxShadow: "0px 12px 30px rgba(0,0,0,0.25)",
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            value={filters.from ? dayjs(filters.from) : null}
            sx={calendarSx}
            // onChange={(v) => {
            //   onFilterChange("from", v?.toDate());
            //   setFromAnchor(null);
            // }}
            onChange={(v) => {
              const formattedDate = v ? v.format("YYYY-MM-DD") : null;
              onFilterChange("from", formattedDate);
              setFromAnchor(null);
            }}
          />
        </LocalizationProvider>
      </Popover> */}

      <Popover
        open={Boolean(fromAnchor)}
        anchorEl={fromAnchor}
        onClose={() => setFromAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            boxShadow: "0px 12px 30px rgba(0,0,0,0.25)",
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            sx={calendarSx}
            value={filters.from ? dayjs(filters.from) : null}
            onChange={(v) => {
              const date = v ? v.format("YYYY-MM-DD") : null;
              onFilterChange("from", date);
              setFromAnchor(null);
            }}
          />
        </LocalizationProvider>
      </Popover>

      {/* ================= TO CALENDAR ================= */}
      {/* <Popover
        open={Boolean(toAnchor)}
        anchorEl={toAnchor}
        onClose={() => setToAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            boxShadow: "0px 12px 30px rgba(0,0,0,0.25)",
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            sx={calendarSx}
            value={filters.to ? dayjs(filters.to) : null}
            // onChange={(v) => {
            //   onFilterChange("to", v?.toDate());
            //   setToAnchor(null);
            // }}
            onChange={(v) => {
              const formattedDate = v ? v.format("YYYY-MM-DD") : null;
              onFilterChange("to", formattedDate);
              setToAnchor(null);
            }}
          />
        </LocalizationProvider>
      </Popover> */}

      <Popover
        open={Boolean(toAnchor)}
        anchorEl={toAnchor}
        onClose={() => setToAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            boxShadow: "0px 12px 30px rgba(0,0,0,0.25)",
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            sx={calendarSx}
            value={filters.to ? dayjs(filters.to) : null}
            onChange={(v) => {
              const date = v ? v.format("YYYY-MM-DD") : null;
              onFilterChange("to", date);
              setToAnchor(null);
            }}
          />
        </LocalizationProvider>
      </Popover>
    </div>
  );
};

UserFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  dropdownOptions: PropTypes.object.isRequired,
  fetchShiftsForBranch: PropTypes.func.isRequired,
  showHistoryFilters: PropTypes.bool,
};

export default UserFilters;
